/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import moment from 'moment'
import ReadAxios from '../../axiosComponent/read'
import JobcardTypeActionBtn from './jobcardTypeActionBtn'
import AgGridTable from '../../agGridComponent/agGridTable';
import Axios from 'axios';

import APP_CONSTANTS from '../../../config/constants';
import { FEATURES } from '../../../utils/constants'


function JobcardTypeTable(props) {
    const [jobcardTypeData, setJobcardTypeData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)

    useEffect(() => {

        setIsLoading(true);

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/jobCardType/?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setJobcardTypeData(response.data.resultSet)
            getProductData(response.data.resultSet)
            setIsLoading(false)
            setSelectedProduct(selectedProductEdit)
        }))
            .catch(error => console.log(error))
            setIsLoading(false)
       
    }, [])

    let rowData = []
    
    let columnDefs = [
        { headerName: 'Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Jobcard Type ', field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Created By', field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Created Date', field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Updated Date', field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true },
        { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
    ]

    jobcardTypeData.map((object, i) => {
        console.log(object,'obj')
        let temp = {}
        temp.code = object.jobCardTypeCode
        temp.name = object.jobCardType
        temp.cby = object.createdByName
        temp.cdate =object.createdOn ?  (object.createdOn).split(' ')[0]: null
        temp.uby = object.updatedByName
        temp.udate = object.updatedOn ? (object.updatedOn).split(' ')[0]: null
        temp.id = object.jobCardTypeId
        temp.customerNo = object.customerNo
        rowData[i] = temp
    })

    if (isLoading) {
        return (
            <LoadingPlaceholder />
        )
    } else {
        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    actionButton={JobcardTypeActionBtn}
                    link="#"
                    hiddenNew={true}
                    newPopup={props.newPopup}
                    // hiddenNewPopupBtn={true}
                    titleBarTitle="Jobcard Type"
                    handleSearch={props.handleSearch}
                    hiddenImportPopupBtn={true}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }

}

export default JobcardTypeTable
